import dayjs from "dayjs";
import LogoIcon from "img/logo_grey.svg";
import { Trans, useTranslation } from "react-i18next";
import { isStaff } from "src/hooks/useUser";

interface AiResponseVerifiedProps {
	approvedBy?: string | null;
	approvedAt?: string | null;
}

export function AiResponseVerified({
	approvedBy,
	approvedAt,
}: AiResponseVerifiedProps) {
	const { t } = useTranslation();
	const showApprovedBy = isStaff() && !!approvedBy;

	return (
		<div className="ai-discussion__verified">
			<div className="ai-discussion__verified-main">
				<LogoIcon className="ai-discussion__verified-logo" />
				<span className="size-14">
					{t(
						"ai.approval.verifiedByModerator",
						"Omówienie zweryfikowane przez moderatora",
					)}
				</span>
			</div>
			{showApprovedBy && (
				<span className="size-10 text-black">
					<Trans
						i18nKey="ai.approval.approvedByInline"
						defaults="Zweryfikował <0>{{user}}</0> dnia <1>{{date}}</1>"
						values={{
							user: approvedBy,
							date: approvedAt
								? dayjs(new Date(approvedAt)).format("DD-MM-YYYY HH:mm")
								: "",
						}}
						components={[<strong key="0" />, <strong key="1" />]}
					/>
				</span>
			)}
		</div>
	);
}
